export const CONSTANTS = {
  Remains: 'Залишок:',
  StartOfAccounting: 'Початок обліку:',
  trackingStartDate: '12.09.2025',
};
